import { isNaN } from 'lodash'

export const isPercentage = (value: number | string) => {
  let float
  if (typeof value === 'number') {
    float = value
  } else if (typeof value === 'string') {
    // Trim whitespace
    value = value.trim()
    const regex = /^\d+%$/
    if (!regex.test(value)) return false
    float = parseFloat(value)
  }
  return !isNaN(float)
}
